const common = {
  'nav.home': 'Startseite',
  'nav.categories': 'Kategorien',
  'nav.guide': 'Guide',
  'nav.buyNow': 'Buy it now',
  'hero.title': 'Oopbuy Spreadsheet Deutschland – Der umfassende Einkaufsleitfaden',
  'hero.subtitle': 'Entdecken Sie die größte deutschsprachige Sammlung von Oopbuy Spreadsheet-Kategorien, Einkaufsratgebern, sicheren Shopping-Tipps und regelmäßig aktualisierten Produktempfehlungen.',
  'hero.cta1': 'oopbuy spreadsheet',
  'hero.cta2': 'Buy it now',
  'trust.daily': 'Täglich aktualisiert',
  'trust.safe': 'Sichere Einkaufsinformationen',
  'trust.compare': 'Detaillierte Vergleichstabellen',
  'trust.free': 'Kostenlose Guides',
  'about.label': 'Was ist Oopbuy Spreadsheet?',
  'about.heading': 'Ihr Schlüssel zu smarter Mode in Deutschland',
  'about.feature1.title': 'Zeitersparnis',
  'about.feature1.desc': 'Alle Produkte auf einen Blick',
  'about.feature2.title': 'Sicherheit',
  'about.feature2.desc': 'Verifizierte Verkäufer',
  'about.feature3.title': 'Aktualität',
  'about.feature3.desc': 'Tägliche Updates',
  'about.feature4.title': 'Community',
  'about.feature4.desc': 'Geprüfte Bewertungen',
  'categories.label': 'Beliebte Kategorien',
  'categories.heading': 'Finden Sie, was Sie suchen',
  'categories.all': 'Alle 14 Kategorien durchstöbern:',
  'dark.heading1': '14 Kategorien.',
  'dark.heading2': 'Unendliche Möglichkeiten.',
  'article.label': 'Neuer Artikel',
  'article.heading': 'Der ultimative Oopbuy Spreadsheet Guide für Deutschland – Sneaker, Streetwear und Luxusmode sicher kaufen',
  'article.readMore': 'Vollständigen Guide lesen',
  'cta.heading': 'JETZT OOPBUY SPREADSHEET ENTDECKEN',
  'cta.subtitle': 'Entdecken Sie die größte deutschsprachige Sammlung von Einkaufsratgebern und Kategorien',
  'footer.brand': 'oopbuyspread.boats',
  'footer.tagline': 'Der vertrauenswürdige Einkaufsbegleiter für modebewusste Käufer in Deutschland.',
  'footer.copyright': 'Alle Rechte vorbehalten.',
  'notFound.title': 'Seite nicht gefunden',
  'notFound.description': 'Die gesuchte Seite existiert leider nicht.',
  'notFound.backHome': 'Zurück zur Startseite',
};

export default common;